import {MessageComponent} from './message-component';

export abstract class DelayedRenderedMessageComponent extends MessageComponent {
}
